module.exports = __webpack_public_path__ + "img/errorLatest.402dc430.svg";